/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';

function ReportViewController(_, $location, ReportViewService, ModalService) {
	var self = this;

	function handleCreateReportModalResult(reportOptions) {
		reportOptions.reportStartDate = self.reportStartDate;
		reportOptions.reportEndDate = self.reportEndDate;
		if (self.selectedPartners) {
			reportOptions.selectedPartners = (_.isArray(self.selectedPartners)) ?
				self.selectedPartners : _.concat(self.selectedPartners);
		}

		ReportViewService.startReportWorkflow(self.selectedReport, reportOptions);
	}

	self.includeHiddenPartners = false;
	self.availableReports = ReportViewService.availableReports;
	self.selectedReport = ReportViewService.getReportForPath($location.path());
	self.enableSubmit = false;

	self.updatePartnerList = function () {
		ReportViewService.queryForPartners(self.includeHiddenPartners).then(function (partners) {
			self.partners = partners;
		});
	};

	self.showReportForm = function () {
		return self.selectedReport.generatorName === ReportViewService.PARTNER_DELIVERY_REPORT_CLASS ||
			self.selectedReport.generatorName === ReportViewService.SLA_DELIVERY_REPORT_CLASS ||
			self.selectedReport.generatorName === ReportViewService.DISTRIBUTION_REPORT_CLASS ||
			self.selectedReport.generatorName === ReportViewService.PARTNER_PROFILES_REPORT_CLASS ||
			self.selectedReport.generatorName === ReportViewService.PARTNER_PLANNER_DELIVERY_REPORT_CLASS ||
			self.selectedReport.generatorName === ReportViewService.AUDIT_LEVEL_REPORT_CLASS;
	};

	self.onSubmit = function () {
		ModalService.showCreateReportModal(self.selectedReport, handleCreateReportModalResult);
	};

	self.handleReportChange = function () {
		$location.path(self.selectedReport.path);
	};

	self.$onInit = () => {
		ReportViewService.doesUserHaveWritePermission(self.selectedReport).then(function (writePermission) {
			self.enableSubmit = writePermission;
		});

		if (self.selectedReport.includePartners) {
			self.updatePartnerList();
		}
	};
}

angular.module('prism-ui.report').component('reportView', {
	controller: ReportViewController,
	templateUrl: 'dashboard/reports/report-view-template.html'
});
